const DraggableTypes = {
  BOX: 'box',
  SAVED_SEARCH: 'saved_search',
  TABLE_COLUMN: 'table_column',
  JOBS_DASHBOARD_WIDGET: 'jobs_dashboard_widget',
};

export default DraggableTypes;

export const ASSET_DRAG_MIME_TYPE = 'application/vnd.iconik.asset';
